import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { isNullOrUndefined } from 'util';

class ProdottoSinistri extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[ProdottoSinistri.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        // this.aggiungiGaranziaOnClick = this.aggiungiGaranziaOnClick.bind(this);
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;

        let type = e.target.type;
        if (type === "number" && value === "") {
            value = null;
        }


        this.props.onChange(id, value);
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <div className="row">
                    <div className="col col-sm-6 col-md-6 col-lg-4">
                        <agui.ATextInputV4 id="numMaxSinistri" type="number"
                            value={this.props.sinistri ? this.props.sinistri.numMaxSinistri : null}
                            disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NR_MAX_SINISTRI', 'Numero massimale di sinistri')}
                            onChange={this.inputChangeHandler} />
                    </div>
                    <div className="col col-sm-6 col-md-6 col-lg-4">
                        <agui.ATextInputV4 id="entitaMaxSingolo" type="number"
                            value={this.props.sinistri ? this.props.sinistri.entitaMaxSingolo : null}
                            disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.ENTITA_MAX_SINGOLE', 'Entità singolo sinistro')}
                            onChange={this.inputChangeHandler} />
                    </div>
                    <div className="col col-sm-6 col-md-6 col-lg-4">
                        <agui.ATextInputV4 id="entitaMediaSinistri" type="number"
                            value={this.props.sinistri ? this.props.sinistri.entitaMediaSinistri : null}
                            disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NR_MEDIA_SINISTRI', 'Entità media sinistri')}
                            onChange={this.inputChangeHandler} />
                    </div>
                </div>
            </div>
        );
    }
};



export default ProdottoSinistri;
